import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { UUID } from 'uuid-generator-ts';

import type { Image } from '@/models/image';

import type { FirebaseError } from 'firebase/app';

type OnError = (errorMessage: string) => void;

export const useFirebaseStorage = (onError: OnError) => {
  let progress = 0;
  let isUploading = false;

  const uploadImage = async (file: File): Promise<Image> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      const storage = getStorage();
      const imageId = new UUID();
      const fileName = `images/${imageId}`;

      const metadata = {
        contentType: file.type,
        customMetadata: {},
      };
      const fileRef = ref(storage, fileName);
      const uploadTask = uploadBytesResumable(fileRef, file, metadata);
      isUploading = true;

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        (error: Error) => {
          console.log('firebase storage error', error);
          isUploading = false;
          const err = error as FirebaseError;
          switch (err.code) {
            case 'storage/canceled':
              onError('アップロードがキャンセルされました。');
              break;
            default:
              onError('アップロードに失敗しました。時間をおいて最後お試しください。');
              break;
          }
          reject(error);
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            console.log('File available at', downloadURL);
            const image = {
              id: imageId.toString(),
              filename: fileName,
              url: downloadURL,
            };
            isUploading = false;
            resolve(image);
          } catch (error) {
            reject(error);
          }
        },
      );
    });
  };

  return { progress, isUploading, uploadImage };
};
